import { Logger } from 'common/log'
import { BaseInterface } from './base'

export class DummyInterface extends BaseInterface {
  logger = new Logger(__filename)
  native = false
  active = false

  private proxyMode = false

  async init () {
    if (!window.dummyPanelInterface && !navigator.userAgent.includes('Electron')) {
      return
    }
    try {
      window.nodeRequire('electron') // debug mode
      this.logger.info('Activating (fake)')
      this.active = true
      this.fs = window.nodeRequire('fs')
    } catch {
    }
  }

  getFS () {
    return this.fs
  }

  getApp () {
    return 'Dummy'
  }

  getPlatform () {
    return null
  }

  hasRestart () {
    return false
  }

  restart () {
    this.logger.warn('restart()')
  }

  importAssets (paths) {
    this.logger.warn('importAssets()', paths)
  }

  getActiveSequencePaths () {
    this.logger.warn('getActiveSequencePaths()')
    return []
  }

  getProjectPaths () {
    this.logger.warn('getProjectPaths()')
    return []
  }

  attachProxies (paths) {
    this.logger.warn('importAssets()', paths)
  }

  isProxyMode () {
    return this.proxyMode
  }

  setProxyMode (enabled) {
    this.proxyMode = enabled
  }

  open (item) {
    this.logger.warn('open()', item)
  }

  hasConfig () {
    return !!window.config
  }

  getConfig (key) {
    return window.config?.get(key)
  }

  setConfig (key, value) {
    return window.config.set(key, value)
  }
}
